import { Heart, Syringe } from 'lucide-react';
import { vaOr, BB_DOC } from './vaOr';

/*
 * VA Cardiac rotation. Blackboard has no cardiac folder; the cardiac room setup is a
 * section of the VA Preop and OR Setup guide. Everything else comes from the General OR
 * rotation through `extends`. See docs/blackboard-va.md.
 */

const GENERAL = BB_DOC('_255081_1');

export const vaCardiac = {
  accent: vaOr.accent,
  icon: Heart,
  tagline: 'Cardiac room setup on top of the Main OR basics',
  notesKey: 'notes:va:cardiac',

  toolSections: [
    { title: 'Clinical tools', tools: [
      { id: 'setup', title: 'Cardiac Room Setup', subtitle: 'Drips, syringes, antibiotics, extras', icon: Syringe, action: 'guide:cardiac-setup', featured: true },
    ] },
    ...vaOr.toolSections.map((s) => ({ ...s, tools: s.tools.filter((t) => !['ebus', 'ect'].includes(t.id)) })),
  ],

  guides: {
    ...vaOr.guides,
    'cardiac-setup': {
      title: 'Cardiac Room Setup',
      sections: [
        { title: 'Drips on the Alaris', blocks: [{ type: 'rows', rows: [
          { label: 'Carrier', value: '500 mL NS with Amicar 10 g or TXA 1–2 g', note: 'Ask the attending which' },
          { label: 'Vasopressin', value: '50 U in 50 mL, 1 U/mL', note: 'Premixed, fridge. First-line pressor' },
          { label: 'Epinephrine', value: '2.5 mg in 250 mL, 10 mcg/mL', note: 'Premixed, fridge' },
          { label: 'Norepinephrine', value: '4 mg in 250 mL, 16 mcg/mL', note: 'Premixed, fridge' },
          { label: 'Insulin', value: '100 U in 100 mL', note: 'Premixed. No tubing until needed' },
        ] }] },
        { title: 'Syringes', blocks: [{ type: 'rows', rows: [
          { label: 'Epinephrine', value: '10 mcg/mL' },
          { label: 'Norepinephrine', value: '16 mcg/mL' },
          { label: 'Phenylephrine', value: '100 mcg/mL' },
          { label: 'Ephedrine', value: '5 mg/mL' },
          { label: 'Nitroglycerin', value: '100 mcg/mL' },
          { label: 'Esmolol', value: 'One 10 mL syringe' },
          { label: 'Midazolam', value: '6 mg' },
          { label: 'Fentanyl', value: '1000 mcg' },
          { label: 'Heparin', value: '3 mg/kg in a 30 mL syringe' },
          { label: 'Amicar or TXA', value: '10 g in 60 mL, or 1–2 g in 20 mL' },
          { label: 'Etomidate', value: 'Drawn' },
          { label: 'Cisatracurium or rocuronium', value: 'Drawn' },
        ] }] },
        { title: 'Also', blocks: [{ type: 'bullets', items: [
          'Vancomycin 1 g in 250 mL NS, or the premixed bag from the fridge',
          'Cefepime 1 g. Penicillin allergy: gentamicin or ciprofloxacin, ask the surgeon',
          'Milrinone and nicardipine drips stay on the cart unopened',
          'NIRS in the room for ascending aorta, arch or carotid surgery',
          'Belmont in the room for thoracoabdominal aneurysm or redo sternotomy',
        ] }] },
      ],
      sources: [{ title: 'VA preop and OR setup', href: GENERAL, detail: 'Blackboard, sign-in required' }],
    },
  },
};
